import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69845926921dc90014acc87b/beautyskinclinic/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69845926921dc90014acc87b/beautyskinclinic/src/components/ui/AppIcon.tsx");
